export { Ng2PicaService } from './src/ng2-pica.service';
export { Ng2PicaModule } from './src/ng2-pica.module';
export { ImgExifService } from './src/img-exif.service';
//# sourceMappingURL=ng2-pica.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-pica/dist/ng2-pica.js
// module id = ./node_modules/ng2-pica/dist/ng2-pica.js
// module chunks = 0